function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imageupload/imageuploadprogress
 */

/* globals setTimeout */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileRepository from '@ckeditor/ckeditor5-upload/src/filerepository';
import uploadingPlaceholder from '../../theme/icons/image_placeholder.svg';
import env from '@ckeditor/ckeditor5-utils/src/env';
import '../../theme/imageuploadprogress.css';
import '../../theme/imageuploadicon.css';
import '../../theme/imageuploadloader.css';
/**
 * The image upload progress plugin.
 * It shows a placeholder when the image is read from the disk and a progress bar while the image is uploading.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageUploadProgress = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageUploadProgress, _Plugin);

  var _super = _createSuper(ImageUploadProgress);

  /**
   * @inheritDoc
   */
  function ImageUploadProgress(editor) {
    var _this;

    _classCallCheck(this, ImageUploadProgress);

    _this = _super.call(this, editor);
    /**
     * The image placeholder that is displayed before real image data can be accessed.
     *
     * @protected
     * @member {String} #placeholder
     */

    _this.placeholder = 'data:image/svg+xml;utf8,' + encodeURIComponent(uploadingPlaceholder);
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageUploadProgress, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor; // Upload status change - update image's view according to that status.

      editor.editing.downcastDispatcher.on('attribute:uploadStatus:image', function () {
        return _this2.uploadStatusChange.apply(_this2, arguments);
      });
    }
    /**
     * This method is called each time the image `uploadStatus` attribute is changed.
     *
     * @param {module:utils/eventinfo~EventInfo} evt An object containing information about the fired event.
     * @param {Object} data Additional information about the change.
     * @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
     */

  }, {
    key: "uploadStatusChange",
    value: function uploadStatusChange(evt, data, conversionApi) {
      var editor = this.editor;
      var modelImage = data.item;
      var uploadId = modelImage.getAttribute('uploadId');

      if (!conversionApi.consumable.consume(data.item, evt.name)) {
        return;
      }

      var fileRepository = editor.plugins.get(FileRepository);
      var status = uploadId ? data.attributeNewValue : null;
      var placeholder = this.placeholder;
      var viewFigure = editor.editing.mapper.toViewElement(modelImage);
      var viewWriter = conversionApi.writer;

      if (status == 'reading') {
        // Start "appearing" effect and show placeholder with infinite progress bar on the top
        // while image is read from disk.
        _startAppearEffect(viewFigure, viewWriter);

        _showPlaceholder(placeholder, viewFigure, viewWriter);

        return;
      } // Show progress bar on the top of the image when image is uploading.


      if (status == 'uploading') {
        var loader = fileRepository.loaders.get(uploadId); // Start appear effect if needed - see https://github.com/ckeditor/ckeditor5-image/issues/191.

        _startAppearEffect(viewFigure, viewWriter);

        if (!loader) {
          // There is no loader associated with uploadId - this means that image came from external changes.
          // In such cases we still want to show the placeholder until image is fully uploaded.
          // Show placeholder if needed - see https://github.com/ckeditor/ckeditor5-image/issues/191.
          _showPlaceholder(placeholder, viewFigure, viewWriter);
        } else {
          // Hide placeholder and initialize progress bar showing upload progress.
          _hidePlaceholder(viewFigure, viewWriter);

          _showProgressBar(viewFigure, viewWriter, loader, editor.editing.view);

          _displayLocalImage(viewFigure, viewWriter, loader);
        }

        return;
      } // Because in Edge there is no way to show fancy animation of completeIcon we need to skip it.


      if (status == 'complete' && fileRepository.loaders.get(uploadId) && !env.isEdge) {
        _showCompleteIcon(viewFigure, viewWriter, editor.editing.view);
      } // Clean up.


      _hideProgressBar(viewFigure, viewWriter);

      _hidePlaceholder(viewFigure, viewWriter);

      _stopAppearEffect(viewFigure, viewWriter);
    }
  }]);

  return ImageUploadProgress;
}(Plugin); // Adds ck-appear class to the image figure if one is not already applied.
//
// @param {module:engine/view/containerelement~ContainerElement} viewFigure
// @param {module:engine/view/downcastwriter~DowncastWriter} writer


export { ImageUploadProgress as default };

function _startAppearEffect(viewFigure, writer) {
  if (!viewFigure.hasClass('ck-appear')) {
    writer.addClass('ck-appear', viewFigure);
  }
} // Removes ck-appear class to the image figure if one is not already removed.
//
// @param {module:engine/view/containerelement~ContainerElement} viewFigure
// @param {module:engine/view/downcastwriter~DowncastWriter} writer


function _stopAppearEffect(viewFigure, writer) {
  writer.removeClass('ck-appear', viewFigure);
} // Shows placeholder together with infinite progress bar on given image figure.
//
// @param {String} Data-uri with a svg placeholder.
// @param {module:engine/view/containerelement~ContainerElement} viewFigure
// @param {module:engine/view/downcastwriter~DowncastWriter} writer


function _showPlaceholder(placeholder, viewFigure, writer) {
  if (!viewFigure.hasClass('ck-image-upload-placeholder')) {
    writer.addClass('ck-image-upload-placeholder', viewFigure);
  }

  var viewImg = viewFigure.getChild(0);

  if (viewImg.getAttribute('src') !== placeholder) {
    writer.setAttribute('src', placeholder, viewImg);
  }

  if (!_getUIElement(viewFigure, 'placeholder')) {
    writer.insert(writer.createPositionAfter(viewImg), _createPlaceholder(writer));
  }
} // Removes placeholder together with infinite progress bar on given image figure.
//
// @param {module:engine/view/containerelement~ContainerElement} viewFigure
// @param {module:engine/view/downcastwriter~DowncastWriter} writer


function _hidePlaceholder(viewFigure, writer) {
  if (viewFigure.hasClass('ck-image-upload-placeholder')) {
    writer.removeClass('ck-image-upload-placeholder', viewFigure);
  }

  _removeUIElement(viewFigure, writer, 'placeholder');
} // Shows progress bar displaying upload progress.
// Attaches it to the file loader to update when upload percentace is changed.
//
// @param {module:engine/view/containerelement~ContainerElement} viewFigure
// @param {module:engine/view/downcastwriter~DowncastWriter} writer
// @param {module:upload/filerepository~FileLoader} loader
// @param {module:engine/view/view~View} view


function _showProgressBar(viewFigure, writer, loader, view) {
  var progressBar = _createProgressBar(writer);

  writer.insert(writer.createPositionAt(viewFigure, 'end'), progressBar); // Update progress bar width when uploadedPercent is changed.

  loader.on('change:uploadedPercent', function (evt, name, value) {
    view.change(function (writer) {
      writer.setStyle('width', value + '%', progressBar);
    });
  });
} // Hides upload progress bar.
//
// @param {module:engine/view/containerelement~ContainerElement} viewFigure
// @param {module:engine/view/downcastwriter~DowncastWriter} writer


function _hideProgressBar(viewFigure, writer) {
  _removeUIElement(viewFigure, writer, 'progressBar');
} // Shows complete icon and hides after a certain amount of time.
//
// @param {module:engine/view/containerelement~ContainerElement} viewFigure
// @param {module:engine/view/downcastwriter~DowncastWriter} writer
// @param {module:engine/view/view~View} view


function _showCompleteIcon(viewFigure, writer, view) {
  var completeIcon = writer.createUIElement('div', {
    class: 'ck-image-upload-complete-icon'
  });
  writer.insert(writer.createPositionAt(viewFigure, 'end'), completeIcon);
  setTimeout(function () {
    view.change(function (writer) {
      return writer.remove(writer.createRangeOn(completeIcon));
    });
  }, 3000);
} // Create progress bar element using {@link module:engine/view/uielement~UIElement}.
//
// @private
// @param {module:engine/view/downcastwriter~DowncastWriter} writer
// @returns {module:engine/view/uielement~UIElement}


function _createProgressBar(writer) {
  var progressBar = writer.createUIElement('div', {
    class: 'ck-progress-bar'
  });
  writer.setCustomProperty('progressBar', true, progressBar);
  return progressBar;
} // Create placeholder element using {@link module:engine/view/uielement~UIElement}.
//
// @private
// @param {module:engine/view/downcastwriter~DowncastWriter} writer
// @returns {module:engine/view/uielement~UIElement}


function _createPlaceholder(writer) {
  var placeholder = writer.createUIElement('div', {
    class: 'ck-upload-placeholder-loader'
  });
  writer.setCustomProperty('placeholder', true, placeholder);
  return placeholder;
} // Returns {@link module:engine/view/uielement~UIElement} of given unique property from image figure element.
// Returns `undefined` if element is not found.
//
// @private
// @param {module:engine/view/element~Element} imageFigure
// @param {String} uniqueProperty
// @returns {module:engine/view/uielement~UIElement|undefined}


function _getUIElement(imageFigure, uniqueProperty) {
  var _iterator = _createForOfIteratorHelper(imageFigure.getChildren()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;

      if (child.getCustomProperty(uniqueProperty)) {
        return child;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
} // Removes {@link module:engine/view/uielement~UIElement} of given unique property from image figure element.
//
// @private
// @param {module:engine/view/element~Element} imageFigure
// @param {module:engine/view/downcastwriter~DowncastWriter} writer
// @param {String} uniqueProperty


function _removeUIElement(viewFigure, writer, uniqueProperty) {
  var element = _getUIElement(viewFigure, uniqueProperty);

  if (element) {
    writer.remove(writer.createRangeOn(element));
  }
} // Displays local data from file loader.
//
// @param {module:engine/view/element~Element} imageFigure
// @param {module:engine/view/downcastwriter~DowncastWriter} writer
// @param {module:upload/filerepository~FileLoader} loader


function _displayLocalImage(viewFigure, writer, loader) {
  if (loader.data) {
    var viewImg = viewFigure.getChild(0);
    writer.setAttribute('src', loader.data, viewImg);
  }
}